import { PRICING_PLAN_TIERS } from '../constants/pricingPlans.constants'
import type { PricingPlanCard } from '../constants/pricingPlans.constants'

/**
 * Tiers shown as "Coming soon" in production. All plans are now live — keep
 * the list empty so every card renders with its real CTA.
 */
const PRODUCTION_COMING_SOON_TIERS: ReadonlyArray<string> = []

/**
 * When Business is in soft launch (`plan.comingSoon`), hide self-serve bucket
 * pricing for new subscribers — except orgs already on Business, who keep
 * upgrade / manage billing.
 */
export function shouldHideBusinessSelfServePricingUi(
  plan: PricingPlanCard,
  orgPlanTier: string | null,
  hasOrg: boolean,
): boolean {
  return (
    plan.tier === PRICING_PLAN_TIERS.BUSINESS
    && plan.comingSoon === true
    && !(orgPlanTier === 'BUSINESS' && hasOrg)
  )
}

/**
 * True when the runtime should treat the pricing UI as production. Either
 * `EXPO_PUBLIC_ENV` (Expo client) or `NODE_ENV` (Node / SSR) being
 * `production` flips us into production mode.
 */
export function isPricingProductionMode(): boolean {
  const expoPublicEnv = (process.env.EXPO_PUBLIC_ENV || '').trim().toLowerCase()
  const nodeEnv = (process.env.NODE_ENV || '').trim().toLowerCase()
  return expoPublicEnv === 'production' || nodeEnv === 'production'
}

/**
 * Returns the plan with `comingSoon` forced on when the runtime is in
 * production mode and the tier is gated; otherwise returns the plan unchanged.
 */
export function resolvePricingPlanForEnv(
  plan: PricingPlanCard,
  isProductionMode: boolean,
): PricingPlanCard {
  if (!isProductionMode) return plan
  if (!PRODUCTION_COMING_SOON_TIERS.includes(plan.tier)) return plan
  if (plan.comingSoon === true) return plan
  return { ...plan, comingSoon: true }
}
